// import { calcTargetItemSize } from './layoutHelper';
import { mergeNestedObjects, flatToNested } from '../helpers/optionsUtils';
export var createOptions = function (options) {
    try {
        var parsedOptions = options.jsonStyleParams
            ? JSON.parse(options.jsonStyleParams)
            : {};
        var combinedOptions = mergeNestedObjects(options, flatToNested(parsedOptions));
        return combinedOptions;
    }
    catch (e) {
        return {};
    }
};
//# sourceMappingURL=designedPresetGallery.js.map